import {
  Row,
  Col,
  Form,
  DatePicker,
  Input,
  message,
  Button,
  Table,
  Typography,
  Modal,
  Select,
} from "antd";
import TextArea from "antd/es/input/TextArea";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import APICaller from "../../utils/APICaller";
import moment from "moment";

import Column from "antd/es/table/Column";
import useCurrentPath, { decryptData } from "../../components/Constants";
import CustomLoader from "../../components/CustomLoader";
import dayjs from "dayjs";
//import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
//import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import { SlideshowLightbox } from "lightbox.js-react";

// dayjs.extend(isSameOrAfter);
// dayjs.extend(isSameOrBefore);

export default function DraftExpenseRequest() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasExecuted = useRef(false); // track first run
  const id = location.pathname?.split("/")?.[3];
  const [form] = Form.useForm();
  const { RangePicker } = DatePicker;

  //All Store values
  let storeRole = useSelector((state) => state.auth.role);
  let storeToken = useSelector((state) => state.auth.accessToken);
  let storeLIUId = useSelector((state) => state.auth.lIUId);

  let storeUserInfo = useSelector((state) => state.auth.userInfo);
  storeUserInfo = decryptData(storeUserInfo);
  const storeEmpID = storeUserInfo?.user?.empID;
  const storeEmpName = storeUserInfo?.user?.name;
  const storeEmpDepartmentID = storeUserInfo?.user?.departmentID;
  const storeEmpDepartmentName = storeUserInfo?.userDepartment;
  const storeEmpDepartmentCode = storeUserInfo?.userDepartmentCode;

  const storeAccessTokenExpiresOn = useSelector(
    (state) => state.auth.accessTokenExpiresOn
  );

  //Initialize state variables
  const [expenseDetail, setExpenseDetail] = useState();
  const [formAction, setFormAction] = useState("");
  const [newFileCount, setNewFileCount] = useState(0);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [addExpenseValues, setAddExpenseValues] = useState(null);
  const [adminApprovers, setAdminApprovers] = useState([]);
  const [projectCodes, setProjectCodes] = useState([]);
  const [blockedDate, setBlockedDate] = useState(null);
  const [expenseCodes, setExpenseCodes] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [allCurrencies, setAllCurrencies] = useState([]);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [mediaItem, setMediaItem] = useState([]);
  const [hasError, setHasError] = useState(false);

  const [natureOfExpenseSelectedValue, setNatureOfExpenseSelectedValue] =
    useState();
  const [showLoader, setShowLoader] = useState(0);
  const [errors, setErrors] = useState([]);

  const isPublishIconClick = location?.state?.publishDraftExpense;

  //SetValue
  const [expenseValues, setExpenseValues] = useState({
    empName: "",
    empID: "",
    departmentID: "",
    expensePeriodFromDate: "",
    expensePeriodToDate: "",
    expenseEmpIDRole: "",
    businessPurpose: "",
    natureOfExpense: "",
    expensesDetails: "",
    subTotal: "",
    totalReimbursement: "",
  });

  const [rows, setRows] = useState([
    {
      date: "",
      description: "",
      departmentID: "",
      expenseCodeID: "",
      currencyID: "",
      cost: "",
      mediaInfo: [],
    },
  ]);

  const [natureOfExpense, setNatureOfExpense] = useState([
    { label: "Already Paid - Filling", value: "Already Paid - Filling" },
    { label: "Reimbursement", value: "Reimbursement" },
    { label: "Travel Settlement", value: "Travel Settlement" },
    { label: "Vendor Bill", value: "Vendor Bill" },
  ]);

  const parseToFloat = (value) => {
    const parsed = parseFloat(value);
    return isNaN(parsed) ? 0 : parsed;
  };
  const subTotal = rows.reduce(
    (total, row) => total + parseToFloat(row.cost),
    0
  );

  const totalReimbursement = subTotal.toFixed(2);

  const images =
    (expenseValues?.expensesDetails &&
      expenseValues?.expensesDetails?.flatMap((detail) =>
        detail.mediaInfo
          ?.filter(
            (file) =>
              file?.savedFileType === "jpeg" ||
              file?.savedFileType === "jpg" ||
              file?.savedFileType === "png"
          )
          ?.map(
            (file) => process.env.REACT_APP_BACKEND + "/" + file?.savedFilepath
          )
      )) ||
    [];

  const blockedOn = blockedDate?.blockedOn && dayjs(blockedDate?.blockedOn);
  const blockedOnMonthStart = blockedOn && blockedOn.startOf("month");

  const validationRules = {
    date: [{ required: true, message: "Please select a date" }],
    description: [{ required: true, message: "Please enter a description" }],
    departmentID: [{ required: true, message: "Please select a department" }],
    expenseCodeID: [
      { required: true, message: "Please select an expense code" },
    ],
    currencyID: [{ required: true, message: "Please enter a currency" }],
    cost: [
      { required: true, message: "Please enter a cost" },
      {
        pattern: /^[0-9]*\.?[0-9]+$/,
        message: "Only numbers and decimals are allowed",
      },
    ],
    upload: [{ required: true, message: "Please choose a file" }],
  };

  const updateRowFiles = (index, fileSources, updatedRows) => {
    if (!updatedRows[index].mediaInfo) {
      updatedRows[index].mediaInfo = [];
    }
    updatedRows[index].mediaInfo = fileSources;

    setRows(updatedRows);

    // Update the mediaInfo in the specific detail
    const updatedDetails = (updatedRows || []).map((item, idx) => {
      if (idx === index) {
        return {
          ...item,
          ["mediaInfo"]: updatedRows[index]["mediaInfo"],
        };
      }
      return item;
    });

    // // Update the state or parent component's state with the updated expenseDetail
    setExpenseValues((prevState) => ({
      ...prevState,
      expensesDetails: updatedDetails,
    }));
  };

  function getMinDate(dateStr) {
    const date = new Date(dateStr); // e.g., "2025-05-22"
    const year = date.getFullYear();
    const month = date.getMonth(); // Current month (0-indexed)

    // Set to 0th day of current month to get last day of previous month
    return new Date(year, month, 0); // e.g., 30 April 2025
  }

  //Rows operations
  const handleAddRow = () => {
    setRows([
      ...rows,
      {
        date: "",
        description: "",
        departmentID: "",
        expenseCodeID: "",
        currencyID: "",
        cost: "",
        mediaInfo: [],
      },
    ]);
  };

  const handleRemoveRow = (indexToRemove) => {
    const updatedRows =
      rows && rows.filter((row, index) => index !== indexToRemove);
    setRows(updatedRows);
    // Convert date fields back to moment objects if they exist
    const updatedFields =
      updatedRows &&
      updatedRows.map((row) => ({
        ...row,
        date: row.date ? moment(row.date) : null,
      }));
    form.setFieldsValue({ rows: updatedFields });
  };

  const handleChange = (index, field, value) => {
    const updatedRows = [...rows];

    if (
      field === "departmentID" ||
      field === "expenseCodeID" ||
      field === "currencyID"
    ) {
      updatedRows[index][field] = value;
    } else {
      updatedRows[index][field] = value;
    }

    //updatedRows[index][field] = value;

    //setRows(updatedRows);

    // Update the mediaInfo in the specific detail
    const updatedDetails = (updatedRows || []).map((item, idx) => {
      if (idx === index) {
        return {
          ...item,
          [field]: updatedRows[index][field],
        };
      }
      return item;
    });

    // // Update the state or parent component's state with the updated expenseDetail
    setExpenseValues((prevState) => ({
      ...prevState,
      expensesDetails: updatedDetails,
    }));
  };

  // Function to remove media
  const handleMediaRemove = (detail, index) => {
    // Show confirmation modal
    Modal.confirm({
      title: "Confirm Removal",
      content: "Are you sure you want to remove this media item?",
      okText: "Yes",
      cancelText: "No",
      onOk: () => {
        // Create a copy of the mediaInfo array for the respective detail
        let updatedMediaInfo = [...detail.mediaInfo];
        // Remove the selected file from the array (e.g., removing the first item for simplicity)
        updatedMediaInfo.splice(0, 1); // You can adjust the index based on your logic

        // Check if mediaInfo is empty after removal and set it explicitly to an empty array
        if (updatedMediaInfo.length === 0) {
          updatedMediaInfo = []; // Set to empty array if no files are left
          //updateRowFiles(index, fileSources, updatedRows);
        }
        // Update the mediaInfo in the specific detail
        const updatedDetails = expenseValues.expensesDetails.map(
          (item, idx) => {
            if (idx === index) {
              return {
                ...item,
                mediaInfo: updatedMediaInfo,
              };
            }
            return item;
          }
        );

        // Update the state or parent component's state with the updated expenseDetail
        setExpenseValues((prevState) => ({
          ...prevState,
          expenseValues: updatedDetails,
        }));
        setRows((prevRows) =>
          prevRows.map((row, idx) => {
            if (idx === index) {
              return {
                ...row,
                mediaInfo: updatedMediaInfo, // Update mediaInfo for the specific row
              };
            }
            return row; // Keep other rows unchanged
          })
        );
        setMediaItem((prevState) => ({
          ...prevState,
          ["item_" + index]: "removed",
        }));

        setNewFileCount(newFileCount - 1);
      },
      onCancel: () => {
        // Optionally, handle cancellation logic here
        console.log("Removal cancelled");
      },
    });
  };

  const handleFileChange = (index, event) => {
    const files = event.target.files;
    if (files.length && files.length > 1) {
      setErrors({ fileCountExceed: true });
      message.error(
        `Only one file can be uploaded. Allowed file types: .jpg, .png, .pdf maximum size: 4MB.`
      );
    } else {
      if (mediaItem?.["item_" + index] === undefined) {
        setMediaItem((prevState) => ({
          ...prevState,
          ["item_" + index]: "freshUpload",
        }));
      }

      setNewFileCount(newFileCount + 1);
      setErrors({ fileCountExceed: false });

      let totalSize = 0;
      const maxTotalSize = 10 * 1024 * 1024; // 10 MB in bytes
      const maxSingleFileSize = 4 * 1024 * 1024; // 5 MB in bytes
      const fileSources = [];
      const updatedRows = [...rows];

      const arrayBufferToBase64 = (buffer) => {
        let binary = "";
        const bytes = new Uint8Array(buffer);
        const len = bytes.byteLength;
        for (let i = 0; i < len; i++) {
          binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
      };

      const loadFile = (file) => {
        const reader = new FileReader();
        const fileType = file.type;
        totalSize += file.size;

        if (file.size > maxSingleFileSize) {
          setErrors({ fileSizeExceed: "single" });
          message.error(`File "${file.name}" exceeds 4MB.\n`);
        } else {
          reader.onload = (e) => {
            if (fileType.startsWith("image/")) {
              // Directly use the base64 data URL for images
              fileSources.push({
                src: e.target.result,
                name: file.name,
                type: fileType,
              });
            } else {
              // Convert ArrayBuffer to base64 for non-image files
              const base64Data = arrayBufferToBase64(e.target.result);
              fileSources.push({
                src: `data:${fileType};base64,${base64Data}`,
                name: file.name,
                type: fileType,
              });
            }

            if (fileSources.length <= 1) {
              updateRowFiles(index, fileSources, updatedRows);
            }
          };

          if (fileType.startsWith("image/")) {
            reader.readAsDataURL(file); // For images
          } else {
            reader.readAsArrayBuffer(file); // For non-image files
          }
        }
      };
      Array.from(files).forEach(loadFile);
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleImageClick = (filePath) => {
    const index = images.findIndex((img) => img === filePath);
    if (index !== -1) {
      setPhotoIndex(index);
      setIsOpen(true);
    }
  };

  const handleButtonClick = (index) => {
    document.getElementById(`fileInput${index}`).click();
  };

  // Add Expense API
  const onFinish = (values) => {
    const formattedDates = Array.isArray(values?.expensePeriodFromDate)
      ? values.expensePeriodFromDate.map((date) =>
          dayjs(date).format("YYYY-MM-DD")
        )
      : [];

    const dateToCheck = formattedDates[0] && dayjs(formattedDates[0]);
    const isBackDated = dateToCheck.isBefore(blockedOnMonthStart);

    if (errors?.fileSizeExceed === "single") {
      message.error("File size exceeds 5 MB.");
    } else if (errors?.fileSizeExceed === "total") {
      message.error("The total size of all files must not exceed 10 MB.");
    } else if (errors?.fileCountExceed) {
      message.error(
        "You cannot only upload one attachment so upload accordingly."
      );
    } else if (totalReimbursement.indexOf("-") !== -1) {
      message.error(
        totalReimbursement +
          " amount is with you. If you have any concern then please contact with Finance Department!!"
      );
    } else if (isBackDated) {
      const messageKey = "publishDraftExpenseError";
      setHasError(true);
      message.open({
        key: messageKey,
        type: "error",
        duration: 0, // stay until closed
        content: (
          <div className="customMsgPopup">
            <span>
              Window Closed! Backdated entry is not allowed. Please update its
              Expense Period and try again.
            </span>
            <Button
              type="link"
              size="small"
              onClick={() => {
                message.destroy(messageKey);
                setHasError(false);
              }}
            >
              X
            </Button>
          </div>
        ),
      });
    } else {
      setAddExpenseValues(values);
      setIsModalVisible(true);
    }
  };

  const handleOk = () => {
    if (!expenseValues) return;
    setIsModalVisible(false);
    setShowLoader(true);
    setErrors({ fileSizeExceed: "", fileCountExceed: false });

    const endpoint = `/publishMulExpense`;
    const method = "PUT";

    const rowsData = expenseValues.expensesDetails.map((detail) => ({
      date: detail.date,
      description: detail.description,
      departmentID: detail.departmentID?._id || detail.departmentID,
      expenseCodeID: detail.expenseCodeID?._id || detail.expenseCodeID,
      currencyID: detail.currencyID?._id || detail.currencyID,
      cost: detail.cost,
      mediaInfo: detail.mediaInfo,
      mediaInfoLength: detail.mediaInfo.length,
    }));

    const payload = {
      action: "publishSingle",
      ids: id,
      newFileCount,
      empName: storeEmpName,
      empID: parseInt(storeEmpID),
      departmentID: expenseValues?.departmentID,
      expensePeriodFromDate: expenseValues?.expensePeriodFromDate,
      expensePeriodToDate: expenseValues?.expensePeriodToDate,
      businessPurpose: expenseValues?.businessPurpose,
      natureOfExpense: expenseValues?.natureOfExpense,
      projectCodeID:
        expenseValues?.projectCodeID?._id || expenseValues?.projectCodeID,
      expensesDetails: rowsData,
      historySource: "portal",
      historyAction:
        formAction === "draft" ? "save as draft" : "Publishing drafted expense",
      historyUserID: storeLIUId,
      status:
        formAction === "draft"
          ? process.env.REACT_APP_DRAFT_STATUS.toUpperCase()
          : process.env.REACT_APP_PENDING_STATUS.toUpperCase(),
       isDrafted: formAction === "draft"
          ? process.env.REACT_APP_DRAFT_STATUS.toUpperCase()
          : null,
    };

    if (adminApprovers.length > 0) {
      if (expenseValues?.empID === storeEmpID) {
        if (expenseValues?.approvers && expenseValues?.approvers.length >= 1) {
          payload.adminSelectedApprover = expenseValues?.approvers[0]
            ?.additional?._id
            ? expenseValues?.approvers[0]?.additional?._id
            : expenseValues?.approvers || "";
        }
      }
    }

    APICaller(
      storeRole,
      storeToken,
      endpoint,
      method,
      payload,
      storeAccessTokenExpiresOn
    )
      .then((response) => {
        message.success(
          formAction === process.env.REACT_APP_DRAFT_STATUS.toLowerCase()
            ? "Expense drafted successfully."
            : "Expense published successfully."
        );
        setShowLoader(false);
        navigate(`/${process.env.REACT_APP_DASHBOARD_EL_SEARCH_IN}`);
      })
      .catch((error) => {
        setShowLoader(false);
      });
  };

  //Fetch Currencies
  const getAllCurrencies = () => {
    const endpoint = "/currency/findAll";
    const method = "POST";
    const payload = {
      fetchWithoutPagination: "yes",
    };

    APICaller(
      storeRole,
      storeToken,
      endpoint,
      method,
      payload,
      storeAccessTokenExpiresOn
    )
      .then((response) => {
        const temp = [];
        response &&
          response?.response?.map((currency, index) => {
            temp.push({
              label: currency?.code,
              value: currency?._id,
            });
          });
        setAllCurrencies(temp);
      })
      .catch((error) => {});
  };

  //Fetch Departments
  const getDepartments = () => {
    const endpoint = "/departments/findAll";
    const method = "POST";
    const payload = {
      fetchWithoutPagination: "yes",
    };

    APICaller(
      storeRole,
      storeToken,
      endpoint,
      method,
      payload,
      storeAccessTokenExpiresOn
    )
      .then((response) => {
        const temp = [];
        response &&
          response?.response?.map((department, index) => {
            temp.push({
              label: `${department?.name} - ${department?.code}`,
              value: department?._id,
            });
          });
        setDepartments(temp);
      })
      .catch((error) => {});
  };

  //Fetch xpenseCodes
  const getExpenseCodes = () => {
    const endpoint = "/expense-code/findAll";
    const method = "POST";
    const payload = {
      fetchWithoutPagination: "yes",
    };
    APICaller(
      storeRole,
      storeToken,
      endpoint,
      method,
      payload,
      storeAccessTokenExpiresOn
    )
      .then((response) => {
        const temp = [];
        response &&
          response?.response?.map((expenseCode, index) => {
            temp.push({
              label: expenseCode?.costCode + " - " + expenseCode?.name,
              value: expenseCode?._id,
            });
          });

        setExpenseCodes(temp);
      })
      .catch((error) => {});
  };

  //Fetch Expense's details
  const getExpenseDetail = async () => {
    try {
      const endpoint = `/list-of-expense/${id}`;
      const method = "GET";
      const payload = {};
      const response = await APICaller(
        storeRole,
        storeToken,
        endpoint,
        method,
        payload,
        storeAccessTokenExpiresOn
      );

      setExpenseValues(response);
      setExpenseDetail(response);

      setNatureOfExpenseSelectedValue(response?.natureOfExpense);

      // Transform the response.expensesDetails to match the rows structure
      if (response?.expensesDetails) {
        const rowsData = response.expensesDetails.map((detail) => ({
          date: detail.date || "", // Map the appropriate fields
          description: detail.description || "",
          departmentID: detail.departmentID?._id || "",
          expenseCodeID: detail.expenseCodeID?._id || null,
          currencyID: detail.currencyID?._id || "",
          cost: detail.cost || "",
          mediaInfo: detail.mediaInfo || [], // If mediaInfo exists
        }));

        // Set the transformed data into the rows state
        setRows(rowsData);
      }
    } catch (error) {
      console.error("Error fetching expense details:", error);
    }
  };

  //Fetch ProjectCodes
  const getProjectCodes = () => {
    const endpoint = "/project-code/findAll";
    const method = "POST";
    const payload = {
      fetchWithoutPagination: "yes",
    };
    APICaller(
      storeRole,
      storeToken,
      endpoint,
      method,
      payload,
      storeAccessTokenExpiresOn
    )
      .then((response) => {
        //const temp = [{ label: "N/A", value: "" }];
        const temp = [];
        response &&
          response?.response?.map((projectCode, index) => {
            temp.push({
              label: projectCode?.code + " - " + projectCode?.companyName,
              value: projectCode?._id,
            });
          });

        setProjectCodes(temp);
      })
      .catch((error) => {});
  };

  //Fetch Admin Approvers
  const getAdminApprovers = () => {
    const endPoint = "/findUserByExpenseCategory";
    const method = "POST";
    const payload = {
      category: process.env.REACT_APP_EXPENSE_CATEGORY_CAPEX,
    };

    APICaller(
      storeRole,
      storeToken,
      endPoint,
      method,
      payload,
      storeAccessTokenExpiresOn
    )
      .then((response) => {
        const temp = [];
        response &&
          response?.map((user) => {
            temp.push({
              label: user?.name,
              value: user?._id,
            });
          });

        setAdminApprovers(temp);
      })
      .catch((error) => {});
  };

  //Expense calendar block status
  const expCal = () => {
    const endpoint = "/expCal";
    const method = "POST";
    const payload = {
      role: storeRole,
      lIUId: storeLIUId,
    };

    APICaller(
      storeRole,
      storeToken,
      endpoint,
      method,
      payload,
      storeAccessTokenExpiresOn
    )
      .then((response) => {
        if (response?.expCalRes) {
          response.expCalRes?.blockedOn &&
          response.expCalRes?.status === process.env.REACT_APP_BLOCK_STATUS
            ? setBlockedDate(response.expCalRes)
            : setBlockedDate(null);
        }
      })
      .catch((error) => {})
      .finally(() => {});
  };

  useEffect(() => {
    getAllCurrencies();
    getDepartments();
    getExpenseDetail();
    getExpenseCodes();
    getProjectCodes();
    expCal();
    if (storeRole === process.env.REACT_APP_ADROLE) {
      getAdminApprovers();
    }
  }, []);

  useEffect(() => {
    if (isPublishIconClick && !hasExecuted.current) {
      hasExecuted.current = true; // mark as executed
      // prevent repeated execution
      setShowLoader(true);
      const endpoint = `/publishMulExpense`;
      const method = "PUT";

      const payload = {
        action: "publishMul",
        ids: [id],
        historySource: "listing-page",
        historyAction: "Publishing drafted expense",
        historyUserID: storeLIUId,
        status: process.env.REACT_APP_PENDING_STATUS.toUpperCase(),
      };
      const messageKey = "publishDraftExpenseError";

      APICaller(
        storeRole,
        storeToken,
        endpoint,
        method,
        payload,
        storeAccessTokenExpiresOn
      )
        .then((response) => {
          setShowLoader(false);

          if (response.statusCode) {
            if (response.message) {
              setHasError(true);
              message.open({
                key: messageKey,
                type: response.statusCode === 400 ? "error" : "success",
                duration: 0, // stay until closed
                content: (
                  <div className="customMsgPopup">
                    <span>{response.message}</span>
                    <Button
                      type="link"
                      size="small"
                      onClick={() => {
                        message.destroy(messageKey);
                        setHasError(false);
                      }}
                    >
                      X
                    </Button>
                  </div>
                ),
              });
            } else {
              message.success("Expense published successfully.");
              navigate(`/${process.env.REACT_APP_DASHBOARD_EL_SEARCH_IN}`);
            }
          }
        })
        .catch((error) => {
          setShowLoader(false);
          message.error("Something went wrong!");
        });
      // Optional: clear the location.state so it won't re-trigger on back
      window.history.replaceState({}, document.title);
    }
  }, [isPublishIconClick]);

  const hasInitialized = useRef(false);

  useEffect(() => {
    if (!expenseDetail) return;

    form.setFieldsValue({
      empID: expenseDetail?.empID,
      empName: expenseDetail?.empName,
      departmentID: `${storeEmpDepartmentName} - ${storeEmpDepartmentCode}`,
      expensePeriodFromDate: [
        dayjs(expenseDetail.expensePeriodFromDate, "YYYY-MM-DD"),
        dayjs(expenseDetail.expensePeriodToDate, "YYYY-MM-DD"),
      ],
      projectCodeID: expenseDetail?.projectCodeID?._id
        ? `${expenseDetail?.projectCodeID?._id}`
        : expenseDetail?.projectCodeID || "",
      natureOfExpense: expenseDetail?.natureOfExpense,
      businessPurpose: expenseDetail?.businessPurpose,
    });
    if (expenseDetail?.empID === storeEmpID) {
      if (expenseDetail?.approvers && expenseDetail?.approvers.length >= 1) {
        form.setFieldsValue({
          approvers: expenseDetail?.approvers[0]?.additional?._id
            ? expenseDetail?.approvers[0]?.additional?._id
            : expenseDetail?.approvers || "",
        });
      }
    }

    if (expenseDetail?.expensesDetails) {
      const rowsData = expenseDetail.expensesDetails.map((detail) => ({
        date: detail.date ? dayjs(detail.date, "YYYY-MM-DD") : null,
        description: detail.description || "",
        departmentID:
          `${detail.departmentID?.name} - ${detail.departmentID?.code}` || "",
        expenseCodeID:
          `${detail.expenseCodeID?.costCode} - ${detail.expenseCodeID?.name}` ||
          null,
        currencyID: detail.currencyID?.code || "",
        cost: detail.cost || "",
        mediaInfo: detail.mediaInfo || [],
      }));

      form.setFieldsValue({
        rows: rowsData,
      });
    }

    // if (
    //   expenseDetail?.status !== process.env.REACT_APP_DRAFT_STATUS.toUpperCase()
    // ) {
    //   navigate("/list-of-expense");
    // }
  }, [expenseDetail]);

  // Preprocess rows to add a stable 'id' if missing
  const rowsWithIds = useMemo(() => {
    return rows.map((item, index) => ({
      ...item,
      id: item.id ?? `row-${index}-${Math.random().toString(36).substr(2, 9)}`,
    }));
  }, [rows]);

  return (
    <div className="container">
      <CustomLoader showLoader={showLoader} />
      <div className="card bgi-no-repeat card-stretch gutter-b border-2 rounded-lg p-0">
        <div className="border-2 card-header p-6">
          <h3 className="card-title m-0 p-0 border-2 font-weight-bolder text-dark font-size-lg">
            Add New Expense
          </h3>
        </div>
        <div className="card-body p-3">
          <Form form={form} layout="vertical" onFinish={onFinish}>
            <Row gutter={[24, 24]}>
              <Col sm={8}>
                <Form.Item
                  className="m-0"
                  label="Employee ID"
                  key="empID"
                  name="empID"
                  rules={[
                    {
                      pattern: /^[0-9]*\.?[0-9]+$/,
                      message:
                        "Alpbhabets and special symbols not allowing in Employee ID",
                    },
                  ]}
                >
                  <Input
                    className="form-control h-45px rounded-md"
                    disabled={expenseValues?.empID !== 1 ? "disabled" : ""}
                    placeholder="Employee ID"
                  />
                </Form.Item>
              </Col>
              <Col sm={8}>
                <Form.Item
                  className="m-0"
                  label="Employee Name"
                  key="empName"
                  name="empName"
                  rules={[
                    {
                      pattern: /^[^\d]*$/,
                      message: "Numbers are not allowed in the employee name",
                    },
                  ]}
                >
                  <Input
                    className="form-control h-45px rounded-md"
                    placeholder="Employee Name"
                    disabled
                  />
                </Form.Item>
              </Col>
              <Col sm={8}>
                <Form.Item
                  className="m-0"
                  label="Department"
                  key="departmentID"
                  name="departmentID"
                >
                  <Input
                    className="form-control h-45px rounded-md"
                    disabled="disabled"
                    placeholder="Select Department"
                  />
                </Form.Item>
              </Col>
              <Col sm={8}>
                <Form.Item
                  className="m-0"
                  label="Expense Period: (From - To)"
                  key="expensePeriodFromDate"
                  name="expensePeriodFromDate"
                  rules={[
                    {
                      required: true,
                      message: "Please enter Expense Period: (From - To)",
                    },
                  ]}
                >
                  <RangePicker
                    className={`form-control h-45px rounded-md d-inline-flex drftRP ${
                      hasError ? "hasError" : ""
                    }`}
                    format="DD-MM-YYYY"
                    disabledDate={(current) => {
                      const minDate = new Date(blockedDate?.blockedOn);
                      return current && current.toDate() <= getMinDate(minDate);
                    }}
                    onChange={(date, dates) => {
                      const formattedDates =
                        dates &&
                        dates.map((date) =>
                          moment(date, "DD-MM-YYYY").format("YYYY-MM-DD")
                        );

                      if (
                        formattedDates &&
                        formattedDates[0] &&
                        formattedDates[1]
                      ) {
                        setExpenseValues({
                          ...expenseValues,
                          expensePeriodFromDate: formattedDates[0],
                          expensePeriodToDate: formattedDates[1],
                        });
                      }
                    }}
                  />
                </Form.Item>
              </Col>
              <Col sm={8}>
                <Form.Item
                  className="m-0"
                  label="Project Code"
                  key="projectCodeID"
                  name="projectCodeID"
                  rules={[
                    {
                      validator: (_, value) => {
                        if (value !== undefined && value !== null) {
                          return Promise.resolve(); // valid
                        }
                        if (value === null) {
                          return Promise.resolve(); // allow 'N/A' case
                        }
                        return Promise.reject("Please select project code");
                      },
                    },
                  ]}
                >
                  <Select
                    showSearch
                    className="h-45px lh-1Pt5 rounded-md"
                    options={projectCodes}
                    onChange={(value) => {
                      setExpenseValues({
                        ...expenseValues,
                        projectCodeID: value,
                      });
                    }}
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                  />
                </Form.Item>
              </Col>

              {storeRole === process.env.REACT_APP_ADROLE && (
                <Col sm={8}>
                  <Form.Item
                    className="m-0"
                    label="Approvers"
                    key="approvers"
                    name="approvers"
                    rules={[
                      {
                        required: true,
                        message: "Please select approver",
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      className="h-45px lh-1Pt5 rounded-md"
                      allowClear
                      options={adminApprovers}
                      onChange={(value) => {
                        setExpenseValues({
                          ...expenseValues,
                          approvers: value,
                        });
                      }}
                      filterOption={(input, option) =>
                        option?.label
                          ?.toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    />
                  </Form.Item>
                </Col>
              )}
              <Col sm={8}>
                <Form.Item
                  className="m-0"
                  label="Nature of Expense"
                  key="natureOfExpense"
                  name="natureOfExpense"
                  rules={[
                    {
                      required: true,
                      message: "Nature of Expense is Mandatory",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    className="h-45px lh-1Pt5 rounded-md"
                    allowClear
                    options={natureOfExpense}
                    onChange={(value) => {
                      setExpenseValues({
                        ...expenseValues,
                        natureOfExpense: value,
                      });
                    }}
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                  />
                </Form.Item>
              </Col>
              <Col sm={8}>
                <Form.Item
                  label="Vendor Name"
                  key="businessPurpose"
                  name="businessPurpose"
                  rules={[
                    {
                      required: true,
                      message: "Please enter vendor name",
                    },
                  ]}
                >
                  <TextArea
                    placeholder="Vendor Name"
                    className="form-control rounded-md"
                    autoSize={{ minRows: 2, maxRows: 4 }}
                    onChange={(e) => {
                      setExpenseValues({
                        ...expenseValues,
                        businessPurpose: e.target.value,
                      });
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>
            <div className="main-repeater mt-10">
              <Table
                className="table"
                dataSource={rowsWithIds}
                rowKey="id"
                pagination={false}
              >
                <Column
                  className="w-120px"
                  title={
                    <>
                      {validationRules.date.some((rule) => rule.required) && (
                        <span className="expenseAddRowRequiredSymbol"></span>
                      )}
                      Date
                    </>
                  }
                  dataIndex="date"
                  key="date"
                  render={(text, record, index) => (
                    <Form.Item
                      key={`date-${index}`}
                      name={["rows", index, "date"]}
                      rules={validationRules.date}
                    >
                      <DatePicker
                        disabledDate={(current) => {
                          const minDate = new Date(blockedDate?.blockedOn);
                          return (
                            current && current.toDate() <= getMinDate(minDate)
                          );
                        }}
                        format="DD-MM-YYYY"
                        value={record?.date ? moment(record?.date) : null}
                        placeholder="Select Date"
                        className="form-control h-45px rounded-md"
                        onChange={(date) => {
                          const formattedDate = date
                            ? date.format("YYYY-MM-DD")
                            : null;
                          handleChange(index, "date", formattedDate);
                        }}
                      />
                    </Form.Item>
                  )}
                />

                <Column
                  className="w-120px"
                  title={
                    <>
                      {validationRules.description.some(
                        (rule) => rule.required
                      ) && (
                        <span className="expenseAddRowRequiredSymbol"></span>
                      )}
                      Description
                    </>
                  }
                  dataIndex="description"
                  key="description"
                  render={(text, record, index) => (
                    <Form.Item
                      key={`description-${index}`}
                      name={["rows", index, "description"]}
                      rules={validationRules.description}
                    >
                      <Input
                        value={record.description}
                        className="form-control h-45px rounded-md"
                        onChange={(e) =>
                          handleChange(index, "description", e.target.value)
                        }
                      />
                    </Form.Item>
                  )}
                />

                <Column
                  className="w-120px"
                  title={
                    <>
                      {validationRules.departmentID.some(
                        (rule) => rule.required
                      ) && (
                        <span className="expenseAddRowRequiredSymbol"></span>
                      )}
                      Department
                    </>
                  }
                  dataIndex="departmentID"
                  key="departmentID"
                  render={(text, record, index) => (
                    <Form.Item
                      key={`departmentID-${index}`}
                      name={["rows", index, "departmentID"]}
                      rules={validationRules.departmentID}
                    >
                      <Select
                        showSearch
                        value={record.departmentID}
                        onChange={(value) =>
                          handleChange(index, "departmentID", value)
                        }
                        className="h-45px rounded-md"
                        options={departments}
                        filterOption={(input, option) =>
                          option?.label
                            ?.toLowerCase()
                            .includes(input.toLowerCase())
                        }
                      />
                    </Form.Item>
                  )}
                />

                <Column
                  className="w-120px"
                  title={
                    <>
                      {validationRules.expenseCodeID.some(
                        (rule) => rule.required
                      ) && (
                        <span className="expenseAddRowRequiredSymbol"></span>
                      )}
                      Expense Code
                    </>
                  }
                  dataIndex="expenseCodeID"
                  key="expenseCodeID"
                  render={(text, record, index) => (
                    <Form.Item
                      key={`expenseCodeID-${index}`}
                      name={["rows", index, "expenseCodeID"]}
                      rules={validationRules.expenseCodeID}
                    >
                      <Select
                        showSearch
                        value={record.expenseCodeID}
                        onChange={(value) =>
                          handleChange(index, "expenseCodeID", value)
                        }
                        className="h-45px rounded-md"
                        options={expenseCodes}
                        filterOption={(input, option) =>
                          option?.label
                            ?.toLowerCase()
                            .includes(input.toLowerCase())
                        }
                      />
                    </Form.Item>
                  )}
                />

                <Column
                  className="w-120px"
                  title={
                    <>
                      {validationRules.currencyID.some(
                        (rule) => rule.required
                      ) && (
                        <span className="expenseAddRowRequiredSymbol"></span>
                      )}
                      Currency
                    </>
                  }
                  dataIndex="currencyID"
                  key="currencyID"
                  render={(text, record, index) => (
                    <Form.Item
                      key={`currencyID-${index}`}
                      name={["rows", index, "currencyID"]}
                      rules={validationRules.currencyID}
                    >
                      <Select
                        showSearch
                        onChange={(value) =>
                          handleChange(index, "currencyID", value)
                        }
                        className="h-45px rounded-md"
                        options={allCurrencies}
                        filterOption={(input, option) =>
                          option?.label
                            ?.toLowerCase()
                            .includes(input.toLowerCase())
                        }
                      />
                    </Form.Item>
                  )}
                />

                <Column
                  className="w-120px"
                  title={
                    <>
                      {validationRules.cost.some((rule) => rule.required) && (
                        <span className="expenseAddRowRequiredSymbol"></span>
                      )}
                      Cost
                    </>
                  }
                  dataIndex="cost"
                  key="cost"
                  render={(text, record, index) => (
                    <Form.Item
                      key={`cost-${index}`}
                      name={["rows", index, "cost"]}
                      rules={validationRules.cost}
                    >
                      <Input
                        type="text"
                        className="form-control h-45px rounded-md"
                        value={record.cost}
                        onChange={(e) =>
                          handleChange(index, "cost", e.target.value)
                        }
                      />
                    </Form.Item>
                  )}
                />

                <Column
                  className="w-90px"
                  title="Upload"
                  dataIndex="upload"
                  key="upload"
                  render={(text, record, index) => {
                    const detail = record;
                    return (
                      <Form.Item key={`upload-${index}`}>
                        {detail?.mediaInfo?.length > 0 &&
                          mediaItem?.["item_" + index] === undefined &&
                          detail?.mediaInfo.map((file, indx) => (
                            <div
                              className="symbol symbol-100 symbol-light mr-3 h-65 float-left border border-light-dark"
                              key={`media-${index}-${indx}`} // ✅ Fix warning
                            >
                              {expenseValues?.empID === storeEmpID &&
                                expenseValues?.status ===
                                  process.env.REACT_APP_DRAFT_STATUS.toUpperCase() && (
                                  <i
                                    className="ki ki-close upload_close"
                                    onClick={() =>
                                      handleMediaRemove(detail, index)
                                    }
                                  ></i>
                                )}
                              {file?.savedFilepath &&
                              ["jpeg", "jpg", "png"].includes(
                                file?.savedFileType
                              ) ? (
                                <SlideshowLightbox>
                                  <img
                                    className="rounded"
                                    src={`${process.env.REACT_APP_BACKEND}/${file?.savedFilepath}`}
                                    alt="media"
                                    width="100"
                                    height="100"
                                    style={{ cursor: "pointer" }}
                                    onClick={() =>
                                      handleImageClick(
                                        `${process.env.REACT_APP_BACKEND}/${file?.savedFilepath}`
                                      )
                                    }
                                  />
                                </SlideshowLightbox>
                              ) : (
                                <div className="align-items-center d-flex h-65px justify-content-center w-65px">
                                  <a
                                    href={`${process.env.REACT_APP_BACKEND}/${file?.savedFilepath}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <i className="flaticon-file-2 uploadIcons"></i>
                                  </a>
                                </div>
                              )}
                            </div>
                          ))}

                        {expenseValues?.status ===
                          process.env.REACT_APP_DRAFT_STATUS.toUpperCase() && (
                          <div>
                            {(mediaItem?.["item_" + index] === "removed" ||
                              mediaItem?.["item_" + index] === "freshUpload" ||
                              detail?.mediaInfo?.length === 0) && (
                              <div className="symbol symbol-100 symbol-light mr-3 h-65 float-left">
                                <input
                                  id={`fileInput${index}`}
                                  type="file"
                                  accept=".png, .jpg, .jpeg, .pdf, .docx, .doc"
                                  onChange={(event) =>
                                    handleFileChange(index, event)
                                  }
                                  style={{ display: "none" }}
                                />
                                <Button
                                  type="primary"
                                  onClick={() =>
                                    document
                                      .getElementById(`fileInput${index}`)
                                      .click()
                                  }
                                  className="redbutton d-block"
                                >
                                  Upload
                                </Button>

                                {detail?.mediaInfo?.length > 0 ? (
                                  <Typography.Text>
                                    {detail.mediaInfo.length} file(s) attached
                                  </Typography.Text>
                                ) : (
                                  <Typography.Text>
                                    Only one file can be uploaded. Allowed file
                                    types: .jpg, .png, max size: 4MB.
                                  </Typography.Text>
                                )}
                              </div>
                            )}
                          </div>
                        )}
                      </Form.Item>
                    );
                  }}
                />

                {rows?.length > 1 && (
                  <Column
                    className="w-90px text-center"
                    title="Actions"
                    key="actions"
                    render={(text, record, index) => (
                      <i
                        className="flaticon-delete icon-lg text-danger cursor-pointer"
                        onClick={() => handleRemoveRow(index)}
                      ></i>
                    )}
                  />
                )}
              </Table>
              <Button
                type="dashed"
                onClick={handleAddRow}
                className="h-auto btn d-block font-size-lg font-weight-bold mx-auto px-5 redbutton rounded-lg text-white"
                style={{ marginTop: 16 }}
              >
                <i className="flaticon2-plus icon-md mr-1 text-white"></i> Add
                More
              </Button>
            </div>
            <Row>
              <Col xs={24}>
                <div className="border-top mb-5 mt-10"></div>
              </Col>

              <Col xs={24}>
                <p className="font-size-h5 font-weight-boldest m-0 ml-auto text-uppercase text-right">
                  Total Reimbursement: {totalReimbursement}
                </p>
              </Col>
              <Col xs={24}>
                <div className="border-top mt-5"></div>
              </Col>
            </Row>
            <div className="text-center mt-5">
              <Button
                type="primary"
                htmlType="submit"
                className="h-auto btn font-size-h5 font-weight-bold mx-5 my-8 px-10 py-3 redbutton rounded-lg text-white"
                onClick={() => {
                  setFormAction("draft");
                }}
              >
                Save
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                className="h-auto btn font-size-h5 font-weight-bold mx-auto my-8 px-10 py-3 redbutton rounded-lg text-white"
                onClick={() => {
                  setFormAction("");
                }}
              >
                Publish
              </Button>
            </div>
            <Modal
              title="Confirm Expense"
              open={isModalVisible}
              onCancel={handleCancel}
              footer={[
                <div
                  key="confirm-buttons"
                  className="addExpenseConfirmationModalFooter"
                >
                  <Button
                    key="submit"
                    className="okSbmit submit-btn border-0 rounded"
                    onClick={handleOk}
                  >
                    Yes
                  </Button>
                  <div className={`loader`}></div>
                </div>,
                <Button
                  key="back"
                  className="cancelSbmit submit-btn border-0 rounded"
                  onClick={handleCancel}
                >
                  No
                </Button>,
              ]}
            >
              {formAction === "draft" ? (
                <p>
                  Please review your entered information before saving the form
                  as a draft. You can make changes later before final submission
                  from <strong>List of Expense</strong>.
                </p>
              ) : (
                <p>
                  Please review your selected or entered information carefully
                  before submitting the form, as changes may not be possible
                  once it's submitted.
                </p>
              )}
            </Modal>
          </Form>
        </div>
      </div>
    </div>
  );
}
// export default function DraftExpenseRequest() {

//   return (
//     <div className="container">
//       <CustomLoader showLoader={showLoader} />
//       <div className="card bgi-no-repeat card-stretch gutter-b border-2 rounded-lg p-0">
//         <div className="border-2 card-header p-6">
//           <h3 className="card-title m-0 p-0 border-2 font-weight-bolder text-dark font-size-lg">
//             Add New Expense
//           </h3>
//         </div>
//         <div className="card-body p-3">
//           <Form form={form} layout="vertical" onFinish={onFinish}>

//             <div className="main-repeater mt-10">
//
//
//             </div>
//
//
//
//           </Form>
//         </div>
//       </div>
//     </div>
//   );
// }
